import { Component, ViewChild, ElementRef, HostListener, EventEmitter, Input, Output,
   OnInit, ChangeDetectionStrategy, AfterViewInit } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { FormControl, FormGroup, FormArray, Validators, FormBuilder } from '@angular/forms';
import {Project, Partner, Country, User, Role, Grade, Class} from '../../../../../projectmanagement/src/app/model/project.model';

import * as projectforms from '../../../../../projectmanagement/src/app/forms/projectmanagement.form';
import { UserManagementService } from '../../../../../tools/src/service/user.management.service';
import { SchoolManagementService } from '../../../../../schoolmanagement/src/app/service/schoolmanagement.service';

import { MyErrorHandler } from '../../errorhandler/errorhandler';
import { TranslateService } from '@ngx-translate/core';

import { isUndefined } from 'util';
import { Select } from '@eds/vanilla/select/Select';
import { Menu } from '@eds/vanilla';


declare var jQuery;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-ctl-user-form',
  templateUrl: './CtlUserForm.html',
  styleUrls: ['./CtlUserForm.css'],
  providers: [UserManagementService, SchoolManagementService]
})

export class CtlUserForm implements OnInit, AfterViewInit {

  @ViewChild('gender') genderDropdown:ElementRef;
  @ViewChild('menu') genderMenu:ElementRef;

  @Input() project_id: string;
  @Input() newPassword: string;
  @Input() school_id: string;
  @Input() school_name: string;
  user_id: string;
  loginGenerated = false;

  loaded = false;

  @Input() myFormGroup: FormGroup;
  @Input() myrole: string;
  @Input() viewType: string;
  @Input() projName:String;
  @Input() myCountry:Country;

  myRoleName: string;

  @Output() userFormChange: EventEmitter<boolean> = new EventEmitter();
  @Output() showDialog: EventEmitter<boolean> = new EventEmitter();
  @Output() enableArchive: EventEmitter<any> = new EventEmitter();
  @Output() editUser: EventEmitter<any> = new EventEmitter();
  // complete form user
  userForm: FormGroup;
  contact: FormGroup;
  logo_url: string;

  user: User;
  curUserActive:Boolean;
  projectData: any;
  schoolData: any;
  roleListData: any[];
  @Input() partnerListData: any[];
  gradeListData: any[] = [];
  classListData: Class[];
  subjectsListData: any[] = [];
  action: string;
  message: string;
  adminActiveArchiveTab: boolean;

  genderSelectConfig = {
    placeholder: 'Select a gender',
    search: false,
    limitTo: 3
  };
  genderList = [
    'Male', 'Female','Other'
  ];

  textDir:any;

  constructor(
    private _fb: FormBuilder,
    private el: ElementRef,
    private userService: UserManagementService,
    private schoolService: SchoolManagementService,
    private router: Router,
    private translate:TranslateService,
    private route: ActivatedRoute) {

      this.textDir =  sessionStorage.getItem('textDir');
      
     }

  ngOnInit() {
    // this.userForm.reset();
    if(this.project_id)
    {
      this.getSubjectsList();
    }
    if (this.school_id) {
      this.getGradeClassList();
    }
    if (this.myFormGroup) {
      this.userForm = this.myFormGroup;
    } else {
      //this.userForm = new FormGroup(projectforms.formUser);
      this.userForm = this._fb.group(projectforms.formUser);
      this.userForm.reset();
    }
    this.getRoleList();

    if (this.myrole) {
      this.myRoleName = this.getRole(this.myrole);
    }

/*     jQuery('.datepicker').datepicker();
 */    
    if (!this.partnerListData) {
      this.partnerListData = JSON.parse(localStorage.getItem('partnerListObj'));
    }
    this.adminActiveArchiveTab = false;
    /*
    this.userForm.valueChanges.subscribe(data => {
        this.userFormChange.emit(true);
    });
    */
  }

  ngAfterViewInit() {
    if (this.myFormGroup) {
      this.userForm = this.myFormGroup;
    } else {
      //this.userForm = new FormGroup(projectforms.formUser);
      this.userForm = this._fb.group(projectforms.formUser);
      this.userForm.reset();
    }
    if (!this.partnerListData) {
      this.partnerListData = JSON.parse(localStorage.getItem('partnerListObj'));
    }
    if (this.myrole) {
      this.myRoleName = this.getRole(this.myrole);
    }
    this.userForm.valueChanges.pipe(debounceTime(500)).subscribe(data => {
        //console.log(JSON.stringify(data));
        this.userFormChange.emit(true);
    });
    const genderSelect = new Select(this.genderDropdown.nativeElement);
    genderSelect.init();
    const genMenu = new Menu(this.genderMenu.nativeElement);
    genMenu.init(); 
    
  }
  showGenDropdown(){
    const genderSelect = new Select(this.genderDropdown.nativeElement);
    genderSelect.init();
    const genMenu = new Menu(this.genderMenu.nativeElement);  
    genMenu.show();
  }
  ngOnDestroy () {
    //
  }

  nameChanged(event) {
    //console.log('changed :' + event.target.value);
    if (!this.userForm.get('username').value && (
      this.userForm.get('first_name').value &&
      this.userForm.get('last_name').value)) {
        //
        this.generateUserPass();
    }
    this.userFormChange.emit(true);
  }

  getProjectData(){
    this.schoolService.getSubjectList(this.project_id).subscribe(
      (response) => {
       this.subjectsListData = response;
       console.log('subjectsListData: ' + JSON.stringify(this.subjectsListData));
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
      console.log('COMPLETED');
      }
    );
  }
  getSubjectsList()
  {
    this.schoolService.getSubjectList(this.project_id).subscribe(
      (response) => {
       this.subjectsListData = response;
       console.log('subjectsListData: ' + JSON.stringify(this.subjectsListData));
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
      console.log('COMPLETED');
      }
    );
  }
  getGradeClassList() {
    this.schoolService.getClassList(this.school_id).subscribe(
      (response) => {
        console.log('Grade List :' + JSON.stringify(response));
        this.classListData = [];
        const classList = response;
        try {
          for (const myclass of classList) {
            if ( myclass.grade &&
              this.gradeListData &&
              this.gradeListData.map(function(e) { return e.name; }).indexOf(myclass.grade.name) === -1) {
              this.gradeListData.push(myclass.grade);
            }
          }

          let i = 0;
          for (const grade of this.gradeListData) {
            this.gradeListData[i].classes = [];
            classList.forEach(item => {
              if (item.grade && grade._id === item.grade._id) {
                if ( this.gradeListData[i].classes.map(function(e) { return e.name; }).indexOf(item.name) === -1 ) {
                  this.gradeListData[i].classes.push({'_id': item._id, 'name': item.name});
                }
              }
            });
            i++;
          }

          //console.log('Grade List Data:' + JSON.stringify(this.gradeListData));
        } catch (err) {
          this.loaded = true;
          return true;
        }
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
      console.log('COMPLETED');
      }
    );
  }

  populateClass(key, val) {
    if (key === 'grade') {
      this.classListData = [];
      if (this.gradeListData) {
        this.gradeListData.forEach(element => {
          if (element._id === val) {
            this.classListData = element.classes;
          }
        });
      }
    }
  }


  myListFormatter(data: any): string {
    console.log('data ' + JSON.stringify(data));
    return data.name;
  }
  myListFormatterForRole(data: any): string {
    console.log('data ' + JSON.stringify(data));
    return data.desc;
  }
  myValueFormatter(data: any): string {
    console.log('data ' + JSON.stringify(data));
    return data.name;
  }

  roleChanged(data: any) {
    if (data && data.name) {
      this.myrole = data.name;
      this.myRoleName = data.desc;
    }
  }

  generateUserPass() {
    let domain = '';
    if (this.projectData && this.projectData.code) {
      domain = this.projectData.code;
    }

    if (this.schoolData && this.schoolData.code) {
      domain = this.schoolData.code;
    }

    const data = {
      'first_name': this.userForm.get('first_name').value,
      'last_name': this.userForm.get('last_name').value,
      'domain': domain
    };

    if (data.first_name && data.last_name && data.domain) {

      this.userService.generateLogin(JSON.stringify(data)).subscribe(
        (response) => {
          console.log(' Full Response User Credential: ' + JSON.stringify(response));
          this.userForm.get('username').patchValue(response.username);
          this.userForm.get('password').patchValue(response.password);
          this.loginGenerated = true;
        },
        (err) => {
          console.log('ERROR: ' + err );
        },
        () => {
          console.log( 'COMPLETED' );
        }
      );
    }
  }

  getRoleList(): any {
    //
    this.userService.listRoles().subscribe(
      (response) => {
       // console.log(' Full Response Role: ' + JSON.stringify(response));
        this.roleListData = response;
        this.loaded = true;
      },
      (err) => {
        console.log('ERROR: ' + err );
      },
      () => {
        //console.log( 'COMPLETED' );
      }
    );
  }

  getRoleID(name: string) {

    console.log('role name :' + name);
    if (this.roleListData && this.roleListData.length) {
      for (let i = 0; i < this.roleListData.length; i++) {
        if (this.roleListData[i].name === name) {
          return this.roleListData[i]._id;
        }
      }
    }
    return;
  }

  getRoleFromID(role_id: string) {

    console.log('role id :' + role_id);
    if (this.roleListData && this.roleListData.length) {
      for (let i = 0; i < this.roleListData.length; i++) {
        if (this.roleListData[i]._id === role_id) {
          return this.roleListData[i].name;
        }
      }
    }
    return;
  }

  getRole(name: string) {

   // console.log('role name :' + name);
    if (this.roleListData && this.roleListData.length) {
      for (let i = 0; i < this.roleListData.length; i++) {
        if (this.roleListData[i].name === name) {
          return this.roleListData[i].desc;
        }
      }
    }
    return;
  }

  setDate(event) {
    if (event.target.value) {
      this.userForm.controls['date_of_birth'].patchValue(event.target.value);
    }
  }

  addUser() {
    const dob = jQuery('#dob').val();
    this.userForm.controls['date_of_birth'].patchValue(dob);
    console.log('CtlUserForm Data for add' + JSON.stringify(this.userForm.value));
    // redirect on success
    const data = this.userForm.value;
    if (this.project_id) {
      data.project_id = this.project_id;
    }
    if (this.school_id) {
      data.school_id = this.school_id;
    }

    if ( data._id) {
      delete data._id;
    }

    if (this.projectData && this.projectData.code) {
      data.domain = this.projectData.code;
    }

    if (this.schoolData && this.schoolData.code) {
      data.domain = this.schoolData.code;
    }

    Object.keys(data).forEach((key) => (data[key] == null) && delete data[key]);
    for (const key of Object.keys(data)) {
      if (key === 'partner') {
        data[key] = data[key]['_id'];
      }
      if (key === 'role') {
        if (data[key] && data[key]['_id']) {
        data['role_id'] = data[key]['_id'];
        delete data.role;
        }
      }
      if (key === 'grade') {
        if (data[key]) {
        data['grade_id'] = data[key];
        }
        delete data.grade;
      }
      if (key === 'class') {
        if (data[key]) {
        data['class_id'] = data[key];
        }
        delete data.class;
      }
      if (key === 'key_subject') {
        if (data[key]) {
        data['key_subject_id'] = data[key];
        }
        delete data.key_subject;
      }
    }

    if (!data.role_id && this.myrole) {
      data.role_id = this.getRoleID(this.myrole);
    }

    console.log("user post data " + JSON.stringify(data));
    this.userService.create(JSON.stringify(data)).subscribe(
      (response) => {
        console.log(' Full Response: ' + JSON.stringify(response));
        this.showDialog.emit(true);
      },
      (err) => {
        this.userFormChange.emit(true);
        console.log('ERROR: ' + err );
      },
      () => {
        console.log('COMPLETED');
      }
    );
  }

  updateUser() {
    if(this.adminActiveArchiveTab)
    { 
      //alert("Updating user")
      this.adminActiveArchiveTab = false;
      if(this.curUserActive)
      {
        this.userService.enable(this.user_id).subscribe(
          (response) => {
            console.log(' Full Response: ' + JSON.stringify(response));
           this.userFormChange.emit(true);
          },
          (err) => {
            this.userFormChange.emit(true);
            console.log('ERROR: ' + err );
          },
          () => {
            console.log('COMPLETED');
          }  
        );
      }else
      {
        this.userService.disable(this.user_id).subscribe(
          (response) => {
            console.log(' Full Response: ' + JSON.stringify(response));
           this.userFormChange.emit(true);
          },
          (err) => {
            this.userFormChange.emit(true);
            console.log('ERROR: ' + err );
          },
          () => {
            console.log('COMPLETED');
          }  
        );
      }
      
      return;
    }
    console.log('save called 2');
    const dob = jQuery('#dob').val();
    this.userForm.controls['date_of_birth'].patchValue(dob);
    console.log('User Form Data 3' + JSON.stringify(this.userForm.value));
    // redirect on success
    let data = this.userForm.value;

    if (this.project_id) {
      data.project_id = this.project_id;
    }
    if (this.school_id) {
      data.school_id = this.school_id;
    }

    if ( data._id) {
      delete data._id;
    }

    if (this.projectData && this.projectData.code) {
      data.domain = this.projectData.code;
    }

    if (this.schoolData && this.schoolData.code) {
      data.domain = this.schoolData.code;
    }

    Object.keys(data).forEach((key) => (data[key] == null) && delete data[key]);
    for (const key of Object.keys(data)) {
      if (key === 'partner') {
        data[key] = data[key]['_id'];
      }
      if (key === 'role') {
        if (data[key] || data[key]['id']) {
          data['role_id'] = data[key]['_id'];
          delete data.role;
        }
      }
      if (key === 'grade') {
        if (data[key]) {
        data['grade_id'] = data[key];
        }
        delete data.grade;
      }
      if (key === 'class') {
        if (data[key]) {
        data['class_id'] = data[key];
        }
        delete data.class;
      }
      if (key === 'key_subject') {
        if (data[key]) {
        data['key_subject_id'] = data[key];
        }
        delete data.key_subject;
      }
    }
    
    //alert("Existing Password: "+ data.password);
    if (!data.role_id && this.myrole) {
      data.role_id = this.getRoleID(this.myrole);
    }
    if(this.newPassword!='')
    {
      data = {'password': this.newPassword};
    }
    console.log("user post data " + JSON.stringify(data));

    this.userService.update(this.user_id, JSON.stringify(data)).subscribe(
      (response) => {
        console.log(' Full Response: ' + JSON.stringify(response));
       this.action = 'success';
       this.message = this.translate.instant('User updated successfully!');
       this.newPassword = '';
       this.userFormChange.emit(true);
      },
      (err) => {
        this.action = 'failure';
        this.message = this.translate.instant('Failed to updated user, try again or contact administrator!');
        this.userFormChange.emit(true);
        console.log('ERROR: ' + err );
      },
      () => {
        console.log('COMPLETED');
      }

    );
  }

  onUserFormSubmit() {
    if (this.user_id) {
      this.updateUser();
    } else {
      this.addUser();
    }
  }

  resetForm() {
    this.userForm = new FormGroup(projectforms.formUser);
    this.userForm.reset();
  }

  formChanged(data) {
    this.userFormChange.emit(true);
  }
  edit() {
    this.viewType = 'edit';
    this.editUser.emit();
  }
  confirmEnableDisable() {
    this.curUserActive = !this.userForm.get('active').value;
    this.adminActiveArchiveTab = true;
    this.enableArchive.emit();
  }
}
